module.exports = __webpack_public_path__ + "img/generation_blue.3c730557.png";